import { render } from "./pendientesdepago.vue?vue&type=template&id=af7bfa84&scoped=true"
import script from "./pendientesdepago.vue?vue&type=script&lang=js"
export * from "./pendientesdepago.vue?vue&type=script&lang=js"

import "./pendientesdepago.vue?vue&type=style&index=0&id=af7bfa84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7bfa84"]])

export default __exports__